// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"de613952","453":"f1fcdd79","504":"f3226f46","897":"753e08e1"}[chunkId] + ".chunk.js";
};